<template>
    <img 
    class="logo-img"
    :class="{small:small}"
    :src="logoSrc"/>
</template>
<script>

const logo = `${window._config.rely}/logo.png`;
const logoS = `${window._config.rely}/logo-small.png`;

export default {
    props: {
        small: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        logoSrc() {
            return this.small ? logoS : logo;
        }
    }
}
</script>
<style lang="scss" scoped>
.logo-img{display:block; height:30px; margin:10px auto;}
</style>